module.exports = require("@nestjs-modules/mailer/adapters/handlebars.adapter");